<template>
	<div class="wrap">
		<div class="content">
			<div class="list">
				<div class="item"  v-if="cardList && (Object.keys(cardList)).length" @click="selectCard">
					<div class="left">
						<img src="@/assets/images/personal/pic_order_cart.png" class="union-card">
						<div>
							<div class="bank-name">{{cardList.bank_name}}</div>
							<div class="card-no">尾号{{cardList.bank_code}}储蓄卡</div>
						</div>
					</div>
                    <img src="@/assets/images/personal/ic_mine_enter.png" class="delete-icon">
                </div>
                
                <div class="item" v-else  @click="addCard">
                	<div class="left">
                		<img src="@/assets/images/my-wallet/pic_mine_add2.png" class="no-card">
                		<span class="add-card">添加银行卡</span>
                	</div>
                
                    <img src="@/assets/images/personal/ic_mine_enter.png" class="delete-icon">
                </div>

            </div>
            
            <div class="bgcolor"></div>
            <div class="amount-wrap">
                <div class="title">提现金额</div>
                <div class="input-wrap">
                    <div class="rmb">¥</div>
                    <cube-input type="number" v-model="amount" placeholder="最低提现金额为1000元" @input="onAmountInput"></cube-input>
                </div>
                <div class="tip-info">
                    <span class="tip" v-if="!isExceed_available_balance">可提现金额 {{walletData.available_balance}}元</span>
                    <span class="tip color-tip" v-if="isExceed_available_balance">超过可提现余额</span>
                    <span class="balance-btn" @click="withdrawAllClick">全部提现</span>
                </div>
                <div 
                  :class="{withdrawBtn: true, disabled: isExceed_available_balance || isEmpty || isLessHundred}" 
                  @click="submitWithDraw"
                >提现</div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
// 在单独构建的版本中辅助函数为 Vuex.mapState
import { mapState } from 'vuex'
import { getMyWallet, getCardList, withdrawBalance } from '@/api/wallet'
import utils from '@/assets/jslibs/utils'

export default {
  name: 'index',
  data() {
  	return {
		cardList:{},
  		options: [
        {label: '1',value: '1', text:'银联'},
  		],
  		amount: '',
  		isExceed_available_balance: false,
  		isEmpty: true,
  		isLessHundred: false,
  		walletData: {},
		isBank:false,
		bankUuid:""						//银行卡uuid'
  	}
  },
	computed: {
		...mapState(['selected_card'])
	},
	  
	components: {
		CommonHeader
	},
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
	
	created(){
		// 获取银行卡列表
		this.getCardList()
	},
	
	mounted() {
		this.getWalletInfo();
        document.title = "提现"
		console.log(this.selected_card, '银行卡')
	},
    
	methods: {
		async getWalletInfo() {
			const { data, status } = await getMyWallet();
			if (status !== 200) return
			if(data){
				this.walletData= data;
			}
		},
		
		async getCardList() {
			const { data, status } = await getCardList();
			if (status !== 200) return
			if(data.data && data.data.length){
				if(this.selected_card && (Object.keys(this.selected_card)).length){//有选择的银行卡
					data.data.forEach((item,index)=>{
						if(item.uuid == this.selected_card.uuid){//当前选择的银行卡存在于银行卡列表（没有被删除）
							this.cardList = this.selected_card;
							this.isBank = true
						}
					})
					if(!this.isBank){
						this.cardList = data.data[0];
						this.cardList.bank_code = this.cardList.bank_code.substr(-4);
						this.bankUuid = this.cardList.uuid;
						this.selected_card.uuid = {};
					}
				}else{
					this.cardList= data.data[0];//默认展示第一个银行卡
					if(this.cardList){
					    this.cardList.bank_code = this.cardList.bank_code.substr(-4);
					    this.bankUuid = this.cardList.uuid;
					}
				}
			}
		},
	
		// 选择银行卡
		selectCard() {
			this.$router.push({
			path: '/bankcard-manage',
			query: {
			  type: 'select',
			}
		  })
		},
        
        addCard(){
            this.$router.push({path:"./add-card",query:{card:"noCard"}})
        },
		
		withdrawAllClick() {
			this.amount = this.walletData.available_balance;
		},
		
		onAmountChange(value) {
			console.log('change', value)
		},
	
		onAmountInput(value) {
			//金额只保留2位小数
			this.$nextTick(()=> {
			this.amount = utils.handleDecimals(value);
			})
			console.log(this.amount, '测试')
			//当用户输入提现金额大于可提现金额时 提现按钮失效 文字提示
			if (+value > +this.walletData.available_balance) {
				this.isExceed_available_balance = true
			} else {
				this.isExceed_available_balance = false
			}
			//根据金额是否为空设置变量值
			value? (this.isEmpty = false) : (this.isEmpty = true)
		},
	
		async submitWithDraw() {
			//超过可退金额无法提交
			if(this.isExceed_available_balance){
				window.toast("提现金额不得超余额","txt");
				return
			}
			if(Number(this.amount) < 1000){
				window.toast("提现金额不得小于1000元","txt");
				return
			}
			
			if(!this.cardList || !Object.keys(this.cardList)){
				window.toast("请先绑定银行卡","txt");
				return
			}
			let postData= {
				type: "1",
				amount: this.amount,
				bank_uuid: this.cardList.uuid || this.bankUuid
			}  

			const { status } = await withdrawBalance(postData);
			if (status !== 200) return
			this.$router.push({
				path: '/withdraw-balancesucc',
				query: {
					type: "1",
					amount: this.amount,
                    bankName:this.cardList.bank_name,
                    bankCode:this.cardList.bank_code
                    
				}
			})
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
.wrap {
	.content {
		.f-s(16);
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(51,51,51,1);
		/deep/.border-top-1px::before, /deep/.border-bottom-1px::after  {
			border: 0;
		}
		/deep/.cube-radio-group {
			.p-t(18);
			background: #fff;
			.weixin-icon, .alipay-icon {
				.m-r(13.5);
			}
			.weixin-icon {
				.w(30);
				.h(27.5);
			}
			.union-icon {
				.w(33.5);
				.h(21);
				.m-r(12);
			}
		}
		.bank-info {
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: #fff;
			.p-b(20);
			.f-s(14);
			.m-l(16);
			.m-r(16);
			.m-t(6);
			.card-info {
	      .card-no {
	      	.f-s(12);
	      	.m-t(6);
					font-family:PingFangSC-Regular;
					font-weight:400;
					color:rgba(102,102,102,1);
	      }
			}
			.right-arrow {
				.w(10);
				.h(17.5);
			}
		}
		
		.list {
			background: #fff;
			.item {
				.h(71);
				.p-l(26);
			  .p-r(33);
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #eee;
				.left {
					display: flex;
					align-items: center;
				}
				.union-card {
					.w(33.5);
					.h(21);
					.m-r(12.5);
				}
				.no-card{
					.w(35);
					.h(35);
				}
				
				.add-card{
					.f-s(15);
					font-family:PingFangSC-Medium;
					font-weight:500;
					color:rgba(51,51,51,1);
					.m-l(16.5)
				}
				.bank-name {
					.f-s(14);
					font-family:PingFangSC-Medium;
					font-weight:500;
					color:rgba(20,20,20,1);
					.m-b(3);	
				}
				.card-no {
					.f-s(12);
					font-family:PingFangSC-Regular;
					font-weight:400;
					color:rgba(102,102,102,1);
					
				}
				.delete-icon {
					.w(10);
					.h(18);
		
				}
			}
		}
		
		.bgcolor {
			.h(10);
			background:rgba(245,245,245,1);
		}
		.amount-wrap {
			.m-l(16);
			.title {
				.m-t(17);
				font-size:16px;
				font-family:PingFangSC-Regular;
				font-weight:400;
				color:rgba(20,20,20,1)
			}
			.input-wrap {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #CFCFCF;
				.m-t(18.5);
				.rmb {
					.f-s(25);
					.m-r(10);
					font-family:PingFangSC-Medium;
					font-weight:500;
					color:rgba(51,51,51,1);
				}
				/deep/.cube-input {
		    	.w(251);
		    }
		    /deep/.cube-input::after {
		    	border: 0;
		    }
			}
			.tip-info {
				padding: 4px 0;
				.tip {
					.f-s(12);
					font-family:PingFangSC-Regular;
					font-weight:400;
					color:rgba(102,102,102,1);
					
					
				}
				.color-tip {
					color:rgba(245,166,35,1);
				}
				.balance-btn {
					.f-s(14);
					.m-l(18);
					font-family:PingFangSC-Regular;
					font-weight:400;
					color:rgba(74,144,226,1);
				}
			}
		}
		.withdrawBtn {
			.w(337.5);
			.h(46);
			.l-h(46);
			.f-s(16);
			.m-t(35);
			background: rgba(74,144,226,1);
			text-align: center;
			border-radius:5px;
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(255,255,255,1);
		}
		.disabled {
      background:rgba(193,193,193,1);
		}
	}
}
</style>